module.exports = function() {
  return new Worker(__webpack_public_path__ + "b545ea60f0969e108ca1.worker.js");
};